import React, { useEffect, useMemo, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

const PURPLE = "#312e81";

function ChartsPage() {
  const navigate = useNavigate();
  const [overview, setOverview] = useState({ markets: [], starline_markets: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    API.get("/charts/overview")
      .then((res) => setOverview(res.data || { markets: [], starline_markets: [] }))
      .catch(() => setOverview({ markets: [], starline_markets: [] }))
      .finally(() => setLoading(false));
  }, []);

  const markets = useMemo(() => overview.markets || [], [overview]);
  const starlineMarkets = useMemo(() => overview.starline_markets || [], [overview]);

  return (
    <div style={page}>
      <header style={header}>
        <button type="button" style={backBtn} onClick={() => navigate(-1)}>
          <ArrowLeft size={22} />
        </button>
        <h1 style={title}>Charts</h1>
        <div />
      </header>

      <main style={main}>
        {loading ? (
          <p style={loadingTxt}>Loading charts…</p>
        ) : (
          <>
            {starlineMarkets.length > 0 && (
              <section style={section}>
                <div style={sectionHdr}>STARLINE CHARTS</div>
                <div style={btnGrid}>
                  {starlineMarkets.map((m) => (
                    <button
                      key={m.id}
                      type="button"
                      style={mktBtn}
                      onClick={() => navigate(`/charts/starline/${m.id}`)}
                    >
                      {m.name}
                    </button>
                  ))}
                </div>
              </section>
            )}

            {markets.length > 0 && (
              <section style={section}>
                <div style={sectionHdr}>PANNA CHARTS</div>
                <div style={btnGrid}>
                  {markets.map((m) => (
                    <button
                      key={m.id}
                      type="button"
                      style={mktBtn}
                      onClick={() => navigate(`/charts/market/${m.id}?view=panel`)}
                    >
                      {m.name}
                    </button>
                  ))}
                </div>
              </section>
            )}

            {markets.length > 0 && (
              <section style={section}>
                <div style={sectionHdr}>JODI CHARTS</div>
                <div style={btnGrid}>
                  {markets.map((m) => (
                    <button
                      key={m.id}
                      type="button"
                      style={mktBtn}
                      onClick={() => navigate(`/charts/market/${m.id}?view=jodi`)}
                    >
                      {m.name}
                    </button>
                  ))}
                </div>
              </section>
            )}

            {!markets.length && !starlineMarkets.length && (
              <p style={emptyTxt}>No chart data available yet.</p>
            )}
          </>
        )}
      </main>
    </div>
  );
}

export default ChartsPage;

const page = {
  minHeight: "100vh",
  background: "#ffffff",
  fontFamily: "Arial, Helvetica, sans-serif",
  color: "#0f172a",
};

const header = {
  position: "sticky",
  top: 0,
  zIndex: 20,
  height: 56,
  background: PURPLE,
  display: "grid",
  gridTemplateColumns: "48px 1fr 48px",
  alignItems: "center",
  padding: "0 10px",
};

const backBtn = {
  width: 36,
  height: 36,
  borderRadius: 8,
  border: 0,
  background: "rgba(255,255,255,0.15)",
  color: "#fff",
  display: "grid",
  placeItems: "center",
  cursor: "pointer",
};

const title = {
  margin: 0,
  textAlign: "center",
  fontSize: 18,
  fontWeight: 900,
  color: "#fff",
  letterSpacing: "0.03em",
};

const main = {
  maxWidth: 960,
  margin: "0 auto",
  padding: "16px 12px 40px",
};

const section = { marginBottom: 8 };

const sectionHdr = {
  background: PURPLE,
  color: "#fff",
  fontWeight: 900,
  fontSize: 14,
  letterSpacing: "0.1em",
  padding: "11px 16px",
  marginBottom: 10,
};

const btnGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
  gap: 8,
  marginBottom: 16,
};

const mktBtn = {
  padding: "11px 8px",
  border: "1.5px solid " + PURPLE,
  borderRadius: 6,
  background: "#fff",
  color: PURPLE,
  fontWeight: 800,
  fontSize: 11,
  cursor: "pointer",
  textAlign: "center",
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  lineHeight: 1.3,
};

const loadingTxt = { textAlign: "center", padding: 32, color: PURPLE, fontWeight: 700 };
const emptyTxt   = { textAlign: "center", padding: 32, color: "#64748b", fontWeight: 700 };
